module.exports = __webpack_public_path__ + "static/media/salviabioelectronics.f86c7fd4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/salviabioelectronics.webp
// module id = 431
// module chunks = 0